import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "time-edit-view" }
const _hoisted_2 = { class: "row v-center gap" }
const _hoisted_3 = { class: "item row col" }
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "row col" }
const _hoisted_6 = { class: "item-box col" }
const _hoisted_7 = { class: "activity-time row gap v-center" }
const _hoisted_8 = { class: "strikethrough" }
const _hoisted_9 = { class: "activity-title" }
const _hoisted_10 = { class: "activity-title" }
const _hoisted_11 = {
  key: 0,
  class: "pd"
}
const _hoisted_12 = {
  key: 1,
  class: "pd"
}
const _hoisted_13 = { class: "row v-center gap spaced" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_si_currency = _resolveComponent("si-currency")!
  const _component_progress_button = _resolveComponent("progress-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        class: "close-button link",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'OrderTime' })))
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "gg-close" }, null, -1)
      ])),
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "fill row center h2" }, "Confirm swap", -1))
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "separator" }, null, -1)),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.error)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "error",
            innerHTML: _ctx.error
          }, null, 8, _hoisted_4))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _cache[10] || (_cache[10] = _createElementVNode("div", null, "Please review and confirm your swap:", -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.source?.name), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.from), 1)
            ]),
            _cache[5] || (_cache[5] = _createElementVNode("div", { class: "gg-arrow-long-right" }, null, -1)),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.target?.name), 1),
              _createTextVNode(" " + _toDisplayString(_ctx.to), 1)
            ])
          ])
        ]),
        (_ctx.priceDifference > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _cache[6] || (_cache[6] = _createTextVNode("This swap will cost an additional ", -1)),
              _createVNode(_component_si_currency, { amount: _ctx.priceDifference }, null, 8, ["amount"]),
              _cache[7] || (_cache[7] = _createTextVNode(", payable on the next step.", -1))
            ]))
          : (_ctx.priceDifference < 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _cache[8] || (_cache[8] = _createTextVNode("This swap will save you ", -1)),
                _createVNode(_component_si_currency, {
                  amount: Math.abs(_ctx.priceDifference)
                }, null, 8, ["amount"]),
                _cache[9] || (_cache[9] = _createTextVNode(". You'll be offered a refund where available; otherwise it stays as a credit on your order.", -1))
              ]))
            : _createCommentVNode("", true),
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "pd gray" }, "No change fee is charged for a swap.", -1))
      ]),
      _cache[14] || (_cache[14] = _createElementVNode("div", { class: "separator" }, null, -1)),
      _createElementVNode("div", _hoisted_13, [
        _createElementVNode("button", {
          class: "row v-center gray",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.go(-1)))
        }, _cache[12] || (_cache[12] = [
          _createElementVNode("span", { class: "gg-chevron-left" }, null, -1),
          _createTextVNode(" Back", -1)
        ])),
        _createVNode(_component_progress_button, {
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirm())),
          showLoader: _ctx.loading,
          disabled: !_ctx.target?.pendingTime
        }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("Confirm", -1)
          ])),
          _: 1,
          __: [13]
        }, 8, ["showLoader", "disabled"])
      ])
    ])
  ]))
}